import { ReactElement } from "react";

import { BaseButton } from "./BaseButton";
import { IButton } from "./types";

export { ButtonColorType, ButtonSize } from "./types";
export type { IButton } from "./types";

export function Button(props: IButton): ReactElement<any, any> {
  return <BaseButton {...props} htmlType="button" />;
}
